// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1Z8j6","primary":"Button_primary__3JYNE","info":"Button_info__R1MdQ","outline":"Button_outline__-7v35"};